// ABOUTME: Admin API client for user management endpoints
// ABOUTME: Provides functions to create, list, and deactivate users

import { apiClient } from './client'
import type { CreateUserRequest, CreateUserResponse, UserListItem, ChangeRoleRequest } from '@/types/admin'

export const adminApi = {
  /**
   * List all users (admin-only)
   */
  async listUsers(): Promise<UserListItem[]> {
    const response = await apiClient.get('/api/admin/users')
    return response.data
  },

  /**
   * Create a new user (admin-only)
   * Returns the generated password - save it immediately!
   */
  async createUser(data: CreateUserRequest): Promise<CreateUserResponse> {
    const response = await apiClient.post('/api/admin/users', data)
    return response.data
  },

  /**
   * Deactivate a user (admin-only)
   */
  async deactivateUser(userId: number): Promise<void> {
    await apiClient.delete(`/api/admin/users/${userId}`)
  },

  /**
   * Reset a user's password (admin-only)
   * Returns the newly generated password - save it immediately!
   */
  async resetPassword(userId: number): Promise<CreateUserResponse> {
    const response = await apiClient.post(`/api/admin/users/${userId}/reset-password`)
    return response.data
  },

  /**
   * Change a user's role (admin-only)
   */
  async changeUserRole(userId: number, data: ChangeRoleRequest): Promise<UserListItem> {
    const response = await apiClient.patch(`/api/admin/users/${userId}/role`, data)
    return response.data
  }
}
